import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Container } from '@stackhouse/styled-elements'

import Toast from '@stackhouse/dashboard-components/Toast'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import SearchBox from '../components/SearchBox'

import { getFormValueMap } from '../utils/form'


const deleteFilterEndpoint = functionName => `/settings/Filter`
const saveFilterEndpoint = functionName => `/settings/Filter/${functionName}`
const savedFiltersEndpoint = functionName => `/settings/Filters/${functionName}`
const filtersConfigEndpoint = functionName => `/settings/FiltersConfig/${functionName}`


class FilterTemplate extends PureComponent {

    constructor(props) {
        super(props)
        this.searchBoxRef = React.createRef()
        this.state = { fields: [], openSections: [] }
    }

    static propTypes = {
        functionName: PropTypes.string,
        fields: PropTypes.object,
        filters: PropTypes.array,
        filterEndpoint: PropTypes.string,
        onResult: PropTypes.func,
        showSort: PropTypes.bool,
        onChangeShowSort: PropTypes.func,
    }

    static forwardedMethods = [
        'loadData',
        'search'
    ]

    componentDidMount() {
        const { withLoader } = this.props
        return withLoader(this.loadData)
    }

    loadData = (callback) => {
        const { client, fields, filters, functionName } = this.props

        const _fields = fields ? fields instanceof Function ? fields() : fields : functionName ? client.get(filtersConfigEndpoint(functionName)).then(res => res.data) : {}
        const _filters = filters ? filters instanceof Function ? filters() : filters : functionName ? client.get(savedFiltersEndpoint(functionName)).then(res => res.data) : []

        return Promise.all([_fields, _filters]).then(([{ filterBoxList, openSection }, filters]) => {
            return this.setState({ fields: filterBoxList, openSections: openSection, filters })
        }).then(callback).catch(callback)
    }

    saveFilter = ({ name, default: isDefault }, filterData, filterQuery, barcodeSearch, callback) => {

        const { client, withLoader, functionName } = this.props

        const filterValue = { query: filterQuery, fields: filterData, barcodeSearch }
        const filterObject = { title: name, default: isDefault, value: JSON.stringify(filterValue) }

        const saveFilter = client.post(saveFilterEndpoint(functionName), filterObject).then(res => res.data)

        return withLoader(done => {
            return Promise.all([saveFilter]).then(([addedFilter]) => {
                setTimeout(Toast.toast({
                    type: 'success',
                    fixed: false,
                    showCloseButton: false,
                    text: `Filter "${name}" saved successfully.`,
                }, { target: 'content' }), 3000)

                return this.setState({ filters: [...this.state.filters, addedFilter] }, callback)
            }).then(done).catch(done)
        })
    }

    deleteFilter = (filter, callback) => {

        const { client, withLoader, functionName } = this.props

        const deleteFilter = client.delete(`${deleteFilterEndpoint(functionName)}/${filter.id}`).then(res => res.data)

        return withLoader(done => {
            return Promise.all([deleteFilter]).then(() => {

                setTimeout(Toast.toast({
                    type: 'success',
                    fixed: false,
                    showCloseButton: false,
                    text: `Filter "${filter.title}" deleted successfully.`,
                }, { target: 'content' }), 3000)

                return this.setState({ filters: this.state.filters.filter(f => f.id != filter.id) }, callback)

            }).then(done).catch(done)
        })
    }

    search = (filtersConfig) => {
        const { withLoader, client, filterEndpoint } = this.props

        if (!filtersConfig) {
            filtersConfig = this.getFilter()
        }
        return withLoader(done => {
            return client.post(filterEndpoint, filtersConfig).then(({ data: result }) => {
                return this.props.onResult(result.elements, result.elementCount)
            }).then(done).catch(done)
        })
    }

    onSearch = (query, filters, barcodeSearch) => {
        const { fields } = this.state

        const filtersConfig = {
            barcodeSearch,
            singleTextSearch: query,
            filterBoxList: getFormValueMap(fields, filters)
        }
        return this.search(filtersConfig)
    }

    getFilter = () => {
        const { fields } = this.state
        const { query, filter, barcodeSearch } = this.searchBoxRef.current.getFilter()

        return {
            barcodeSearch,
            singleTextSearch: query,
            filterBoxList: getFormValueMap(fields, filter)
        }
    }

    render() {
        const { fields, openSections, filters } = this.state
        return (
            <Container flex={0}>
                <SearchBox
                    ref={this.searchBoxRef}
                    fields={fields}
                    openSections={openSections}
                    filters={filters}
                    saveFilter={this.saveFilter}
                    deleteFilter={this.deleteFilter}
                    onSearch={this.onSearch}
                    showSort={this.props.showSort}
                    onChangeShowSort={this.props.onChangeShowSort}
                />
            </Container>
        )
    }
}


export default withDashboardContext(FilterTemplate, ({ client, withLoader }) => ({ client, withLoader }))